<script lang="ts" setup>
import SkeletonNpsPromoterUrl from '../../visualAssets/SkeletonNpsPromoter.svg?url';
import SkeletonNpsNeutralUrl from '../../visualAssets/SkeletonNpsNeutral.svg?url';
import SkeletonNpsDetractorUrl from '../../visualAssets/SkeletonNpsDetractor.svg?url';
import { Type } from '../../utility';

defineProps<{
  type: Type;
  inPopup?: boolean;
}>();

const skeletonImages: Record<Type, string | null> = {
  Positive: SkeletonNpsPromoterUrl,
  Neutral: SkeletonNpsNeutralUrl,
  Negative: SkeletonNpsDetractorUrl,
  Null: null,
};
</script>
<template>
  <div class="flex flex-col" v-if="inPopup">
    <div class="loading-gradient h-[10px] w-[67px] rounded-2"></div>
    <div class="flex flex-row">
      <div class="loading-gradient h-[10px] w-[35px] rounded-2 mt-3"></div>
      <div class="pl-1 sm:text-3 xl:text-3 font-bold xs:text-4 md:text-4 flex flex-row items-center"></div>
    </div>
  </div>
  <img
    v-if="!inPopup && skeletonImages[type]"
    :src="skeletonImages[type]!"
    class="grid-column[1-1] mr-4 w-24px h-24px"
    alt=""
  />
  <div v-if="!inPopup" class="grid-column[2-2] mr-4 loading-gradient h-[10px] w-[67px] rounded-2"></div>
  <div
    v-if="!inPopup"
    class="sm:text-3 xl:text-3 grid-column[4-4] font-bold xs:text-4 md:text-4 flex flex-row items-center"
  ></div>
</template>
